import React from 'react';
import { UserRole } from '../../types/lms.types';

interface ContentTabsProps {
  activeTab: string;
  onTabChange: (tab: string) => void;
  userRole: UserRole
}

const ContentTabs: React.FC<ContentTabsProps> = ({ activeTab, onTabChange, userRole }) => {
  const tabs1 = [
    { id: 'all', label: 'All', icon: '🌟' },
    { id: 'add-group', label: 'Add-Group', icon: '📁'},
    { id: 'assessments', label: 'Assessments', icon: '📝' },
    { id: 'materials', label: 'Materials', icon: '📁' },
    { id: 'announcements', label: 'Announcements', icon: '📢' },
    { id: 'glossary', label: 'Glossary', icon: '📖' },
    { id: 'co', label: 'CO', icon: '🎯' },
    { id: 'po', label: 'PO', icon: '🏆' },
    { id: 'grades', label: 'Grades', icon: '📊' },
    
  ];
  const tabs2 = [
    { id: 'all', label: 'All', icon: '🌟' },
    { id: 'assessments', label: 'Assessments', icon: '📝' },
    { id: 'materials', label: 'Materials', icon: '📁' },
    { id: 'announcements', label: 'Announcements', icon: '📢' },
    { id: 'glossary', label: 'Glossary', icon: '📖' },
    { id: 'co', label: 'CO', icon: '🎯' },
    { id: 'po', label: 'PO', icon: '🏆' },
    { id: 'grades', label: 'Grades', icon: '📊' },
    
  ];

  return (
  <div className="border-b border-gray-200 dark:border-gray-700 mb-0">
    <nav className="-mb-px flex space-x-2 overflow-x-auto">
      {(userRole === 'teacher' ? tabs1 : tabs2).map((tab) => (
        <button
          key={tab.id}
          onClick={() => onTabChange(tab.id)}
          className={`py-3 px-4 border-b-2 font-medium text-sm flex items-center gap-2 whitespace-nowrap ${
            activeTab === tab.id
              ? 'border-blue-500 text-blue-600 dark:text-blue-400'
              : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 dark:text-gray-400 dark:hover:text-gray-300'
          }`}
        >
          <span>{tab.icon}</span>
          <span className="hidden sm:inline">{tab.label}</span>
        </button>
      ))}
    </nav>
  </div>
);
};

export default ContentTabs;
